import accessLocalStorage from './accessLocalStorage';

const MASTER_TENANT = 'vgs';

export const getEffectiveTenant = () => {
  const data = accessLocalStorage.getUserLocalStorage();
  return (data && data.user && data.user.idtenant) || null;
};

export const isMasterTenant = (idtenant) => idtenant === MASTER_TENANT;

export const scopeByTenant = (list, getItemTenant, idtenant) => {
  const tenant = idtenant === undefined ? getEffectiveTenant() : idtenant;
  const items = Array.isArray(list) ? list : [];
  if (isMasterTenant(tenant)) return items;
  return items.filter((item) => getItemTenant(item) === tenant);
};
